import script from "./BloodDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BloodDetails.vue?vue&type=script&setup=true&lang=js"

import "./BloodDetails.vue?vue&type=style&index=0&id=bffad9bc&lang=scss"

const __exports__ = script;

export default __exports__